export class CardTypes {

  getCardArray() {
    return [
      {
        'label': 'Instant Issue' ,
        'value' : 'temp'
      },
      {
        'label': 'EMV Instant Issue' ,
        'value' : 'emvbulk'
      },
      {
        'label' : 'Visitor',
        'value': 'visitor'
      },
      {
        'label' : 'EMV Visitor',
        'value': 'emvvisitor'
      }
    ];
  }

}
